import { Button } from 'antd'
import React, { FunctionComponent, useContext } from 'react'
import { LoaderContext } from '../loader/loader-middleware'

interface SubmitCancelProps {
  shouldDisplayPrevious: boolean
  isSubmit: boolean
  onPrevious?: () => void
}

const SubmitCancel: FunctionComponent<SubmitCancelProps> = ({
  shouldDisplayPrevious,
  isSubmit,
  onPrevious,
}) => {
  const { loading } = useContext(LoaderContext)

  return (
    <>
      <div className="flex flex-col-reverse md:flex-row justify-around md:my-8 gap-4 md:gap-0">
        {shouldDisplayPrevious ? (
          <Button
            type="primary"
            shape="round"
            className=""
            onClick={onPrevious}
            style={{ minWidth: '15rem' }}
          >
            Cancel
          </Button>
        ) : null}

        <Button
          type="default"
          shape="round"
          className="font-medium"
          htmlType="submit"
          loading={loading}
          style={{ minWidth: '15rem' }}
        >
          {loading && 'Processing'}
          {!loading && (isSubmit ? 'Submit Request' : 'Next')}
        </Button>
      </div>
    </>
  )
}

export default SubmitCancel
